import { http } from '@/http'

// CDEF010: campos personalizados (definición en Mantenimiento; valores en el formulario de cada entidad).
// entity: COLABORADOR | CONTRATO | EMPRESA | CARGO | AREA | SEDE
export default {
  list(entity)                       { return http.get('/custom-fields', { params: { entity } }) },
  create(data)                       { return http.post('/custom-fields', data) },
  update(id, data)                   { return http.put(`/custom-fields/${id}`, data) },
  changeStatus(id, status)           { return http.put(`/custom-fields/${id}/status`, null, { params: { status } }) },
  getValues(entity, entityId)        { return http.get(`/custom-fields/values/${entity}/${entityId}`) },
  saveValues(entity, entityId, list) { return http.put(`/custom-fields/values/${entity}/${entityId}`, list) },
  // Catálogo unificado de variables de plantilla (nativas + personalizadas).
  variables()                        { return http.get('/template-variables') },
}
